var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgNftOwned = function SvgNftOwned(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "nft-owned_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#nft-owned_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "m21.246 8.674-2.313-3.829A1.767 1.767 0 0 0 17.432 4H6.56c-.61 0-1.191.328-1.502.845L2.747 8.674a1.75 1.75 0 0 0 .26 2.128l7.748 8.69c.34.339.79.508 1.241.508.45 0 .901-.169 1.242-.507l7.747-8.691c.57-.567.681-1.442.26-2.128Zm-13.744 1.8L9.664 16.3 4.8 10.474h2.703Zm5.986-4.972 1.401 3.48H9.093l1.402-3.48h2.993Zm1.351 4.972-2.853 7.358-2.852-7.358h5.705Zm1.642 0h2.702L14.32 16.3l2.162-5.827Zm1.161-4.853 2.032 3.361h-3.173l-1.402-3.48h2.333c.09 0 .17.05.21.119Zm-11.301 0c.04-.08.13-.12.21-.12h2.332L7.482 8.983H4.309L6.34 5.621Z",
    fill: "currentColor"
  }))));
};
export default SvgNftOwned;